module.exports = __webpack_public_path__ + "img/tarot-major-arcana-11.0676c077.png";